module.exports = __webpack_public_path__ + "media/src/images/payment_systems/invoice_de-82f3e9f405c2a1b9e466e85bdb1e69a0.png";